import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=64d9635c&"
import script from "./DesignView.vue?vue&type=script&lang=js&"
export * from "./DesignView.vue?vue&type=script&lang=js&"
import style0 from "./DesignView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports